import { ControlType, Property, PropertyType } from "../../../base/types";
import { FC, useEffect } from "react"
import { IControlAttributes, ITableLookup } from "../../../base/models";
import { useCreateMessageMutation, useGetMessagesByIdQuery } from "../../../services/data";

import { Chat } from "./Chat";
import { IChatMessage } from "../../../data";
import { Registry } from "../../../base/register";
import { useAuth } from "../../../../modules/auth";
import { useGetProperties } from "../../../base/hooks";

export const ChatComponent: FC<IControlAttributes> = ({
    control, className, children, props, designerMode, ...rest
}) => {
    const { properties } = useGetProperties({ bindings: control.bindings });
    const entityId: string | undefined = properties[Property.EntityId];
    const entity: string | undefined = properties[Property.Entity]
    const title: string | undefined = properties[Property.Title]
    const headerClass: string | undefined = properties[Property.HeaderClass]
    const collapsible: boolean | undefined = properties[Property.Collapsible]
    const tableLookup: ITableLookup = properties[Property.TableLookup] || {};
    const { user } = useAuth()

    return (
        <div className={className}>
            {entity && entityId ?
                <ChatWrapper
                    title={title}
                    icon="ChatOutlined"
                    headerClass={headerClass}
                    collapsible={collapsible}
                    entity={`${entity}`}
                    tableLookup={tableLookup}
                    contactId={user?.contactId}
                    entityId={entityId} /> :
                <Chat
                    title={title}
                    icon="ChatOutlined"
                    headerClass={headerClass}
                    collapsible={collapsible}
                    messages={[]}
                    contactId={user?.contactId}
                    tableLookup={tableLookup}
                    onSendMessage={() => { }} />
            }
        </div>)
}

export const ChatWrapper = ({ entity, entityId, title, icon, headerClass, collapsible, contactId, tableLookup }: {
    title?: string,
    tableLookup: ITableLookup,
    icon?: string,
    entity: string,
    entityId: string,
    headerClass?: string,
    contactId?: string,
    collapsible?: boolean
}) => {
    const { data, isSuccess, refetch } = useGetMessagesByIdQuery({ entity, entityId });
    const [sendMessage] = useCreateMessageMutation();

    useEffect(() => {
        setInterval(() => {
            refetch();
        }, 1000 * 60)

        // eslint-disable-next-line
    }, [isSuccess])

    const handleSendMessage = (message: Partial<IChatMessage>) => {
        sendMessage({
            ...message,
            entity,
            entityId,
            userName: contactId,
        })
            .unwrap()
            .then(message => console.log("message", message))
            .catch(err => console.log("err", err));
    }

    return <Chat
        title={title}
        icon={icon}
        headerClass={headerClass}
        collapsible={collapsible}
        messages={data || []}
        contactId={contactId}
        tableLookup={tableLookup}
        recordId={entityId}
        onSendMessage={handleSendMessage} />
}

Registry.addControl({
    id: "18b25576-48a3-48a9-8591-0a0d3465121a",
    name: "Chat",
    type: ControlType.Chat,
    properties: [
        { id: Property.Title, name: 'Title', type: PropertyType.String },
        { id: Property.Entity, name: 'Entity', type: PropertyType.Entity },
        { id: Property.EntityId, name: 'EntityId', type: PropertyType.String },
        { id: Property.Collapsible, name: 'Collapsible', type: PropertyType.Boolean },
        { id: Property.HeaderClass, name: 'Header Class', type: PropertyType.String },
        { id: Property.TableLookup, name: 'Table Lookup', type: PropertyType.TableLookup },
    ],
    component: ChatComponent
})
